<template>
    <v-card :loading="progress" id="bnft-wishlist-create-form" class="mx-auto rounded-lg elevation-0">
        <template slot="progress">
            <div style="
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                " class="d-flex justify-center align-center">
                <v-progress-circular color="primary" size="400" width="2" indeterminate></v-progress-circular>
            </div>
        </template>
        <v-form ref="form" v-model="valid" class="bnft-wishlist-create-form" :class="$vuetify.breakpoint.mobile ? 'mobile' : ''">
            <v-list-item three-line :class="$vuetify.breakpoint.mobile ? 'px-0' : ''">
                <v-list-item-content>
                    <v-row>
                        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 8">
                            <v-text-field class="font-weight-light font-italic" :dense="$vuetify.breakpoint.mobile" id="name" label="My Bra Wishlist Name" outlined v-model="$storeWishlistname"></v-text-field>
                            <v-textarea id="description" class="font-weight-light font-italic" :rows="3" outlined validate-on-blur name="description" label="My Bra Wishlist Description..." v-model="
                                    $storeWishlistDescription
                                "></v-textarea>
                        </v-col>
                        <v-col>
                            <v-card color="#EEEEEE" elevation="0">
                                <!-- beautify ignore:start --><file-pond
                                    v-if="server"
                                    ref="filepond_wishlist"
                                    name="filepond_wishlist"
                                    label-idle="Wishlist Photo"
                                    accepted-file-types="image/*"
                                    :files="files.wishlist"
                                    @removefile="
                                        (error, file) =>
                                            removefileHandler(file, 'wishlist')
                                    "
                                    @processfile="
                                        (error, file) =>
                                            processfileHandler(file, 'wishlist')
                                    "
                                    :beforeRemoveFile="beforeRemoveFilepondHandler"
                                    :value="filepondWishlistValue"
                                    :stylePanelLayout="
                                        ['compact', 'integrated'][1]
                                    "
                                    :server="server"
                                    :credits="null"></file-pond
                                ><!-- beautify ignore:end -->
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row class="mb-4">
                        <!-- <pre>
                            valid: {{ valid }}
                            wishlistItem: {{ wishlistItem.size }}
                            files.bras: {{ files }}
                        </pre> -->

                        <v-container class="bra d-flex" :class="
                                $mobile ? '' : 'elevation-1 rounded-xl mx-4'
                            " id="bra">
                            <v-row>
                                <v-col :cols="$mobile ? 12 : 4">
                                    <v-row>
                                        <v-col :cols="
                                                $vuetify.breakpoint.mobile
                                                    ? 6
                                                    : 4
                                            " :class="
                                                $vuetify.breakpoint.mobile
                                                    ? 'pt-0 pr-1 pb-0'
                                                    : 'pr-0'
                                            ">
                                            <v-text-field class="font-weight-light font-italic" :dense="
                                                    $vuetify.breakpoint.mobile
                                                " id="bra_brand" :rules="rules.brand" label="Bra Brand" outlined v-model="
                                                    $storeWishlistItemBrand
                                                "></v-text-field>
                                        </v-col>
                                        <v-col :cols="
                                                $vuetify.breakpoint.mobile
                                                    ? 6
                                                    : 4
                                            " :class="
                                                $vuetify.breakpoint.mobile
                                                    ? 'py-0 pl-1'
                                                    : 'pr-0'
                                            ">
                                            <v-text-field class="font-weight-light font-italic" :dense="
                                                    $vuetify.breakpoint.mobile
                                                " id="bra_name" :rules="rules.name" label="Bra Name" outlined v-model="$storeWishlistItemName" :value="
                                                    edit
                                                        ? wishlist.description
                                                        : ''
                                                "></v-text-field>
                                        </v-col>
                                        <v-col :cols="
                                                $vuetify.breakpoint.mobile
                                                    ? 6
                                                    : 3
                                            " :class="
                                                $vuetify.breakpoint.mobile
                                                    ? 'py-0 pr-1'
                                                    : ''
                                            ">
                                            <v-text-field class="font-weight-light font-italic" :dense="
                                                    $vuetify.breakpoint.mobile
                                                " id="bra_size" validate-on-blur :rules="rules.size" label="Bra Size" hint="band and cup (i.e. 32N)" outlined v-model="
                                                    $storeWishlistItemSize
                                                "></v-text-field>
                                        </v-col>
                                        <v-col :cols="
                                                $vuetify.breakpoint.mobile
                                                    ? 2
                                                    : 1
                                            " id="tour-step-color" class="d-flex justify-space-end" :class="
                                                $vuetify.breakpoint.mobile
                                                    ? 'py-0 pl-1'
                                                    : 'px-0'
                                            ">
                                            <v-sheet elevation="4" class="pointer" style="z-index: 1" @click.self="swatchClickHandler" rounded :height="brasizeInputHeight" :width="brasizeInputHeight" :color="
                                                    activeItemBraColor && activeItemBraColor.startsWith(`#`) ? activeItemBraColor : activeItemBraColor ? `#${activeItemBraColor}` : ''
                                                ">
                                                <!-- this span encapsulation is needed because the v-color-picker event is not working -->
                                                <span @click="swatchInputHandler">
                                                    <v-color-picker :swatches="braColors" label="Bra Color" v-model="colorPicker" :show-swatches="
                                                            showSwatches
                                                        " hide-canvas hide-inputs hide-sliders dot-size="40"></v-color-picker>
                                                </span>
                                            </v-sheet>
                                            <v-input type="hidden" :rules="rules.color" :value="swatch" ref="bra_color" id="bra_color"></v-input>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col :cols="$mobile ? 12 : 6">
                                    <p class="font-italic text-body-2 mx-md-6">
                                        <v-textarea id="description" class="font-weight-light mt-2" :rows="3" outlined name="bra_description" label="All about this bra..." :rules="rules.description" v-model="
                                                $storeWishlistItemDescription
                                            "></v-textarea>
                                        <v-text-field ref="bra_url" :dense="$vuetify.breakpoint.mobile" @change="uniqueURL" id="url" name="bra_url" label="Website Link" outlined v-model="$storeWishlistItemUrl" :rules="rules.url"></v-text-field>
                                        <v-input :rules="rules.gift" :value="$storeWishlistItemMSRP" hide-details>
                                            <bnft-gift-amount :readonly="edit && !sActiveItemId.match(/default|temp-.*/) ? true : false" defaultCurrency="USD" v-model="$storeWishlistItemMSRP" @rules="giftRulesEventHandler" label="MSRP" dense hide-actions></bnft-gift-amount>
                                        </v-input>
                                        <v-btn v-show="Object.keys($storeItems).length" :disabled="!valid" @click="addButtonHandler" small text>
                                            <v-icon left>
                                                add_circle_outline </v-icon>Add another bra
                                        </v-btn>
                                    </p>
                                </v-col>
                                <v-col :cols="$mobile ? 12 : 2">
                                    <v-card color="#EEEEEE" elevation="0">
                                        <!-- beautify ignore:start --><file-pond
                                            v-if="server"
                                            ref="filepond_bra"
                                            name="filepond_bra"
                                            label-idle="Bra Photo(s)"
                                            class="max-height: 300px"
                                            accepted-file-types="image/*"
                                            :files="files.bras"
                                            @removefile="
                                                (error, file) =>
                                                    removefileHandler(
                                                        file,
                                                        'bras'
                                                    )
                                            "
                                            @processfile="
                                                (error, file) =>
                                                    processfileHandler(
                                                        file,
                                                        'bras'
                                                    )
                                            "
                                            :beforeRemoveFile="beforeRemoveFilepondHandler"
                                            :value="
                                                !sActiveItemId.match(/default|temp-.*/) &&
                                                assets['bras'] &&
                                                assets['bras'][sActiveItemId].serverId
                                            "
                                            :stylePanelLayout="
                                                ['compact', 'integrated'][1]
                                            "
                                            :server="server"
                                            :credits="null"></file-pond
                                        ><!-- beautify ignore:end -->
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-row>
                    <v-row>
                        <v-col cols="12" :class="$mobile ? 'pa-0' : ''">
                            <v-list v-if="Object.keys($storeItems).length >= 1" :class="$mobile ? 'py-0 ma-0' : 'mx-8'">
                                <v-list-item v-for="(item, i) in $storeItems" :key="i" :class="$mobile ? 'px-0 ma-0' : ''">
                                    <v-list-item-icon small>
                                        <v-btn x-small text @click="editButtonHandler(i)" :class="$mobile ? 'ml-1' : ''">
                                            <v-icon small class="mr-2">edit</v-icon>
                                        </v-btn>
                                    </v-list-item-icon>
                                    <v-list-item-title class="d-flex" :class="$mobile ? '' : 'mx-4'">
                                        <span class="mr-2 font-italic">{{
                                            item.size
                                        }}</span>{{ item.name }}
                                        <span v-if="NODE_ENV !== 'production' && !$mobile" class="ml-16">{{
                                            item && item.id && item.id.gtin
                                        }}</span>
                                        <div class="text-truncate" :class="$mobile ? '' : 'mx-4'" :style="$mobile ? 'max-width: 400px' : 'max-width: 500px'">{{ item.url }}</div>
                                    </v-list-item-title>
                                    <v-list-item-action v-if="item.balance">
                                        <v-tooltip :disabled="item.balance && item.balance[0] == 0" left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-on="on" v-bind="attrs">
                                                    <v-btn :disabled="item.balance && item.balance[0] > 0" x-small text @click="removeButtonHandler(i)" :class="$mobile ? 'mr-4' : ''">
                                                        <v-icon small class="mr-2">delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </template>
                                            <span>Item's with balances cannot be deleted.</span>
                                        </v-tooltip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
            <v-card-actions class="justify-center">
                <v-btn @click="$emit('cancel')" small text> Cancel </v-btn>
                <v-btn :small="$vuetify.breakpoint.mobile" @click="submit" outlined text>
                    {{ edit ? 'Update' : 'Create' }} Wish List
                </v-btn>
            </v-card-actions>
        </v-form>
        <v-snackbar color="#F44336" bottom :timeout="-1" :value="error">
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="error = false">Close</v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>
<style>
.v-text-field .v-label {
    overflow: unset;
}
.wishlist-item {
    background-color: notice;
}
</style>
<script>
import { nanoid } from 'nanoid';
import { until } from 'async';
import { mdiChevronLeft, mdiChevronRight, mdiChevronDown } from '@mdi/js';
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';
import whilst from 'async/whilst';
import * as Promise from 'bluebird';
import 'animate.css';
import BnftGiftAmount from './BnftGiftAmount.vue';

const BraRegEx = new RegExp(
    /^(2[89]|[3-9]\d|10[0-2])(d{1,3}|e{1,3}|f{1,3}|g{1,3}|h{1,3}|i{1,3}|j{1,3}|k{1,3}|l{1,3}|m{1,3}|n{1,3}|o{1,3}|p{1,3}|q{1,3}|r{1,3}|s{1,3}|t{1,3}|u{1,3}|v{1,3}|w{1,3}|x{1,3}|y{1,3}|z{1,3})/
);

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFilePoster
);

export default {
    name: 'BnftcreateWishlistForm',
    components: {
        FilePond,
        BnftGiftAmount,
    },
    props: {
        value: Boolean,
        wallet: Object,
        edit: Boolean,
        create: Boolean,
        wishlist: Object,
    },
    filters: {},
    data: function () {
        const { NODE_ENV, VUE_APP_API_SERVER } = process.env;
        return {
            NODE_ENV,
            VUE_APP_API_SERVER,
            error: false,
            errorMessage: null,
            files: {
                bras: null,
                wishlist: null,
            },
            debounce: false,
            showSwatches: false,
            swatches: [
                { black: '#000000' },
                { white: '#FFFFFF' },
                { grey: '#9E9E9E' },
                { nude: '#E3BC9A' },
                { red: '#F44336' },
                { pink: '#E91E63' },
                { purple: '#9C27B0' },
                { wine: '#673AB7' },
                { indigo: '#3F51B5' },
                { blue: '#2196F3' },
                { icy: '#03A9F4' },
                { cyan: '#00BCD4' },
                { teal: '#009688' },
                { green: '#4CAF50' },
                { apple: '#8BC34A' },
                { lime: '#CDDC39' },
                { yellow: '#FFEB3B' },
                { amber: '#FFC107' },
                { orange: '#FF9800' },
                { tangarine: '#FF5722' },
                { brown: '#795548' },
            ],
            token: null,
            valid: false,
            slideGroup: null,
            mdiChevronLeft,
            mdiChevronRight,
            mdiChevronDown,
            brasizeInputHeight: null,
            brasizeInputWidth: null,
            description: this.$storeDescription,
            rules: {
                brand: [(v) => !v || (!!v && true)],
                name: [(v) => !v || (!!v && true)],
                size: [
                    () =>
                        (!!this.braBand && !!this.braCup) ||
                        'Band and cup size please.',
                ],
                description: [
                    (v) => !v || v.length < 500 || 'Description is too long.',
                ],
                url: [
                    (v) => !!v || 'URL is required.',
                    (v) =>
                        /https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(
                            v
                        ) || 'Invalid URL (http(s) URLs are supported)',
                    (v) => (v && v.length < 2000) || 'Url is too long.',
                ],
                asset: this.assetRules,
                gift: undefined,
            },
            assetRules: null,
            show: false,
            account: null,
            listing: null,
            aliases: null,
            overlays: {
                unverified: false,
            },
            unverifiedUserErrorEmitted: false,
            server: null,
            wishlistItem: {
                bra: {
                    brand: null,
                    name: null,
                    color: '#000000',
                    size: {},
                },
                size: null,
                description: null,
                mutableId: null,
                charity: null,
                url: null,
                media: {
                    url: [],
                },
            },
            progress: false,
            colorPicker: null,
        };
    },
    watch: {
        assetRules(value) {
            this.$set(this.rules, 'asset', value);
        },
        braSize(value) {
            if (value?.band && value?.cup)
                this.wishlistItem.size = value.band + value.cup.toUpperCase();
        },
        colorPicker(value) {
            if (!this.activeItemBraColor) return;
            this.sActiveItem.bra.color = value.hex;
        },
        wishlist(value) {
            if (value.id && value.id.match(/^temp-.*/)) return;
            this.populateForm(value);
        },
        value(value) {
            if (value && !this.edit) {
                this.$store.commit('resetForm', 'createWishlist');
                this.newWishlist();
            } else if (value && this.edit) {
                this.populateForm(this.wishlist);
            }
        },
    },
    computed: {
        filepondWishlistValue() {
            return this.assets['wishlist']?.length
                ? this.assets.wishlist.find((file) => file.serverId).serverId
                : undefined;
        },
        activeItemBraColor() {
            return this.sActiveItem?.bra?.color;
        },
        imageExtension() {
            const ext = /^((?!chrome|android).)*safari/i.test(
                window?.navigator?.userAgent
            )
                ? 'jpeg'
                : 'webp';
            return ext;
        },
        callbackErrorCode() {
            return this.$store.state.errorCode;
        },
        callbackErrorMessage() {
            return this.$store.state.errorCode;
        },
        assets() {
            return {
                wishlist: this.$store.state.form.createWishlist.media,
                bras: Object.entries(
                    this.$store.state.form.createWishlist.items
                ).reduce(
                    (assets, assetsPerItem) => ({
                        ...assets,
                        [assetsPerItem[0]]: assetsPerItem[1].media,
                    }),
                    {}
                ),
            };
        },
        filepondBraRef() {
            const { assets, sActiveItemId } = this;
            if (!assets?.bras?.length) return;
            return assets?.bras?.length && assets.bras[sActiveItemId].serverId
                ? `filepond_bra_${assets['bras'][sActiveItemId].serverId}`
                : `filepond_bra_${assets['bras'][sActiveItemId].url}`;
        },
        braColors() {
            return [this.swatches.map((c) => Object.values(c)[0])];
        },
        swatch() {
            const self = this;
            const swatch = this.swatches.find((s) => {
                const re =
                    typeof s === 'object'
                        ? new RegExp(`${Object.values(s)[0]}`, 'i')
                        : new RexExp('^#(?:[0-9a-fA-F]{3,4}){1,2}$', i);
                return (
                    self.sActiveItem?.bra?.color &&
                    self.sActiveItem.bra.color.match(re)
                );
            });
            return swatch
                ? JSON.stringify({
                      name: Object.keys(swatch)[0],
                      color: Object.values(swatch)[0],
                  })
                : JSON.stringify({ black: '#000000' });
        },
        braBand() {
            let band;
            const match = this.$storeWishlistItemSize
                ? this.$storeWishlistItemSize.toLowerCase().match(BraRegEx)
                : null;
            if (match && match.length > 0) {
                band = match[1];
                this.$store.commit('updateItemBandSize', band);
            }
            return band;
        },
        braCup() {
            let cup;
            const match = this.$storeWishlistItemSize
                ? this.$storeWishlistItemSize.toLowerCase().match(BraRegEx)
                : null;
            if (match && match.length > 1) {
                cup = match[2];
                this.$store.commit('updateItemCupSize', cup);
            }
            return cup;
        },
        braSize() {
            return this.braCup && this.braBand
                ? { band: this.braBand, cup: this.braCup }
                : undefined;
        },
        username() {
            const username = this.$auth.user.nickname;
            const usernameArray = username.match(/(.*)\s\((.*)\)\s(.*)/);
            if (!usernameArray) {
                this.$emit('unverified');
                return {
                    full: 'BraNFT™ (Not Verified) User',
                    first: 'BraNFT™',
                    firstPlural: `BraNFT's`,
                    last: 'User',
                    nickname: 'Not Verified',
                };
            }
            const first = usernameArray[1],
                firstPlural = usernameArray[1].endsWith('s')
                    ? `${usernameArray[1]}'`
                    : `${usernameArray[1]}'s`,
                last = usernameArray[3],
                nickname = usernameArray[2];
            return { full: username, first, firstPlural, last, nickname };
        },
        $storeItems: {
            get: function () {
                return this.$store.state.form.createWishlist.items;
            },
            set: function (value) {
                this.$store.commit('updateWishlistItems', value);
            },
        },
        $storeWishlistname: {
            get: function () {
                return this.$store.state.form.createWishlist.name;
            },
            set: function (value) {
                this.$store.commit('updateWishlistName', value);
            },
        },
        $storeWishlistDescription: {
            get: function () {
                return this.$store.state.form.createWishlist.description;
            },
            set: function (value) {
                this.$store.commit('updateWishlistDescription', value);
            },
        },
        $storeWishlistMutableId: {
            get: function () {
                return this.$store.state.form.createWishlist.mutableId;
            },
            set: function (value) {
                this.$store.commit('updateWishlistMutableId', value);
            },
        },
        $storeWishlistCharity: {
            get: function () {
                return this.$store.state.form.createWishlist.charity;
            },
            set: function (value) {
                this.$store.commit('updateWishlistCharity', value);
            },
        },
        $storeWishlistItemMSRP: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ].id?.msrp || this.$store.state.wishlistItem.msrp
                );
            },
            set: function (value) {
                this.$store.commit('updateItemMSRP', value);
            },
        },
        $storeWishlistItemBrand: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ]?.bra?.brand || this.$store.state.wishlistItem.bra.brand
                );
            },
            set: function (value) {
                this.$store.commit('updateItemBrand', value);
            },
        },
        $storeWishlistItemName: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ]?.bra?.name || this.$store.state.wishlistItem.bra.name
                );
            },
            set: function (value) {
                this.$store.commit('updateItemName', value);
            },
        },
        $storeWishlistItemDescription: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ]?.description || this.$store.state.wishlistItem.description
                );
            },
            set: function (value) {
                this.$store.commit('updateItemDescription', value);
            },
        },
        $storeWishlistItemSize: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ]?.size || this.$store.state.wishlistItem.size
                );
            },
            set: function (value) {
                this.$store.commit('updateItemSize', value);
            },
        },
        $storeWishlistItemUrl: {
            get: function () {
                return (
                    this.$store.state.form.createWishlist.items[
                        this.sActiveItemId
                    ]?.url || this.$store.state.wishlistItem.url
                );
            },
            set: function (value) {
                this.$store.commit('updateItemUrl', value);
            },
        },
        sActiveItemId: {
            get: function () {
                return this.$store.state.form.createWishlist.activeItemId;
            },
            set: function (value) {
                this.$store.commit('updateActiveItemId', value);
            },
        },
        sActiveItem() {
            return this.$store.state.form.createWishlist.items[
                this.$store.state.form.createWishlist.activeItemId
            ];
        },
    },
    mounted() {
        const self = this;
        (async function () {
            self.token = await self.$auth.getTokenSilently();

            self.$set(self, 'server', {
                url: `${self.VUE_APP_API_SERVER}/v1/account/upload`,
                withCredentials: true,
                instantUpload: true,
                headers: {
                    Authorization: `Bearer ${self.token}`,
                },
                process: {
                    onload: self.filepondOnload,
                    onerror: self.filepondProcessOnError,
                },
                load: {
                    onerror: self.filepondLoadOnError,
                },
            });
            if (self.edit) {
                self.populateForm(self.wishlist);
            } else {
                self.$store.commit('resetForm', 'createWishlist');
                self.restoreFilePond();
                self.newWishlist();
            }
        })();
    },
    methods: {
        giftRulesEventHandler(event) {
            this.$set(this.rules, 'gift', event);
        },
        uniqueURL(value) {
            const isADuplicateURL =
                Object.values(this.$storeItems).filter(
                    (item) => item.url === this.$storeWishlistItemUrl
                ).length > 1;
            if (!isADuplicateURL) return;
            const url = new URL(value);
            url.searchParams.append('branfts.com', nanoid(2));
            this.$storeWishlistItemUrl = url.toString();
        },
        newWishlist() {
            this.$emit('created', `temp-${nanoid()}`);
        },
        async populateForm(wishlist) {
            this.$store.commit('resetForm', 'createWishlist');
            
            const items = Object.values(wishlist.items).reduce(
                (items, item) => ({
                    ...items,
                    [`${wishlist.id} ${item.id.gtin}`]: {
                        ...item,
                        size: `${item?.bra?.size?.band || ''}${
                            item?.bra?.size?.cup || ''
                        }`,
                    },
                }),
                {}
            );

            this.$storeItems = items;
            this.sActiveItemId = Object.keys(items)[0];
            this.$storeWishlistname = wishlist?.name;
            this.$storeWishlistDescription = wishlist?.description;
            this.$storeWishlistMutableId = wishlist?.mutableId;
            this.$storeWishlistCharity = wishlist?.charity;
            await this.rendered();
            if (this.wishlist?.media?.length) {
                const file = await fetch(this.wishlist.media[0].url);
                this.files.wishlist = [
                    {
                        url: this.wishlist.media[0].url,
                        source: await file.blob(),
                        options: {
                            type: 'local',
                        },
                        file,
                    },
                ];
                await this.populateFilepondBraImages();
            }
        },
        async populateFilepondBraImages() {
            if (this.sActiveItem?.media?.length) {
                this.files.bras = await Promise.all(
                    this.sActiveItem.media.map(async (media) => {
                        if (media.url) {
                            const file = await fetch(media.url);
                            return {
                                url: media.url,
                                source: await file.blob(),
                                options: {
                                    type: 'local',
                                },
                                file,
                            };
                        }
                        return {
                            source: media.serverId,
                            options: {
                                type: 'local',
                            },
                        };
                    })
                );
            } else {
                this.$refs.filepond_bra.removeFile();
            }
        },
        restoreFilePond() {
            const self = this;
            const { sActiveItemId } = this;
            if (sActiveItemId === 'default') return;
            Object.keys(this.assets).map((asset) => {
                // prettier-ignore
                //console.log({asset}, this.assets)
                if (
                    !this.assets[asset] || asset === 'bras'
                        ? !this.assets[asset][sActiveItemId].serverId
                        : !this.assets[asset].serverId
                ) {
                    until(
                        function test(cb) {
                            const filepondBraRef = self.$refs[`filepond_bra_${self.assets['bras'][sActiveItemId]?.serverId}`]
                            cb(null, filepondBraRef || self.$refs.filepond_wishlist);
                        },
                        function iter(next) {
                            setTimeout(() => next(), 1);
                        },
                        function done() {
                            const filepondBraRef = self.$refs[`filepond_bra_${self.assets['bras'][sActiveItemId]?.serverId}`]
                            if (filepondBraRef && asset === 'bras') filepondBraRef.removeFile();
                            if (self.$refs.filepond_wishlist) self.$refs.filepond_wishlist.removeFile();
                        }
                    );
                }
                //console.log('restoring filepond.', this.assets[asset][0]?.serverId || this.assets[asset]?.serverId);
                if (
                    !this.assets[asset][sActiveItemId]?.serverId ||
                    this.assets[asset]?.serverId
                )
                    return;
                this.$set(this.files, asset, [
                    {
                        source:
                            asset === 'bras'
                                ? this.assets[asset][sActiveItemId].serverId
                                : this.assets[asset].serverId,
                        options: {
                            type: 'local',
                        },
                    },
                ]);
            });
        },
        handleCallbackErrors: function () {
            const { errorCode, errorMessage } = this.$route.query;
            this.$store.commit({ type: 'set', errorCode });
            this.$store.commit({ type: 'set', errorMessage });
            this.$router
                .replace({ 'query.errorCode': undefined })
                .catch(() => {});
            this.$router
                .replace({ 'query.errorMessage': undefined })
                .catch(() => {});
            this.$root.$emit(
                'nearUserRejected',
                decodeURIComponent(errorMessage)
            );
        },
        onClickOutside: function () {
            if (this.debounce) return;
            this.closeAllOverlays();
        },
        closeAllOverlays() {
            const self = this;
            Object.keys(self.overlays).map((overlay) => {
                self.$set(self.overlays, overlay, false);
            });
        },
        swatchClickHandler() {
            const self = this;
            if (self.debounce) return;
            self.debounce = setTimeout(() => {
                self.debounce = false;
            }, 100);
            this.showSwatches = true;
        },
        swatchInputHandler() {
            const self = this;
            self.debounce = setTimeout(() => {
                self.debounce = false;
            }, 100);
            this.showSwatches = false;
        },
        beforeRemoveFilepondHandler(file) {
            file;
            /**
             * https://pqina.nl/filepond/docs/api/instance/properties/#callbacks
             * FilePond is about to remove this file, return false to prevent removal, or return a Promise and resolve with true or false.
             */
            //if (typeof file.serverId !== 'string') delete file.serverId;
            return true;
        },
        removefileHandler(file, label) {
            file;
            const input = this.$refs.form.$data.inputs.find(
                (input) => input.id === label
            );
            if (input) input.reset();
        },
        processfileHandler(filepond, label) {
            const asset =
                label === 'bras'
                    ? this.assets[label][this.sActiveItemId]
                    : this.assets[label];
            if (filepond.fileType.match(/image\/.*/)) {
                const canvas = document
                    .querySelector(`[id$="${filepond.id}"]`)
                    .querySelector('canvas');
                if (!canvas) return;

                const thumbnail = document.createElement('canvas');
                thumbnail.width = 100;
                thumbnail.height = 100;
                const ctx = thumbnail.getContext('2d');
                ctx.drawImage(
                    canvas,
                    0,
                    0,
                    150,
                    (300 * canvas.height) / canvas.width
                );
                asset.thumb = thumbnail.toDataURL(
                    `image/${this.imageExtension}`
                );
            }
            asset.type = filepond.fileType;
            asset.url = URL.createObjectURL(filepond.file);
            /*const assets = { ...this.assets };
            label === 'bras'
                ? (assets[label][this.sActiveItemId] = asset)
                : (assets[label] = asset);
            this.$store.commit('updateWishlistAssets', assets);
            */
            // prettier-ignore
        },
        addButtonHandler() {
            // prettier-ignore
            if (this.valid) {
                const tempItemId = `temp-${nanoid()}`
                this.$set(this.$storeItems, tempItemId, { ...this.$store.state.wishlistItem })
                this.sActiveItemId = tempItemId
                this.populateFilepondBraImages();
            }
        },
        async editButtonHandler(id) {
            this.sActiveItemId = id;
            this.populateFilepondBraImages();
        },
        async removeButtonHandler(id) {
            this.$store.commit('deleteWishlistItems', [id]);
            this.sActiveItemId = Object.keys(this.$storeItems)[0];
            this.populateFilepondBraImages();
        },
        async submit() {
            const self = this;

            if (self.unverifiedUserErrorEmitted) {
                self.unverifiedUserErrorEmitted = false;
                this.$auth.getTokenSilently({ ignoreCache: true }).then(() => {
                    self.submit();
                });
                return;
            }
            if (!this.$refs.form.validate()) return;

            const filteredItems = Object.values(this.$storeItems).map(
                (item) => ({
                    ...Object.fromEntries(
                        Object.entries(item)
                            .filter(([, v]) => v != null && v != '')
                            .map((item) => {
                                //console.log('item: ', item);
                                if (item[0] === 'media') {
                                    return item[1].length &&
                                        item[1]
                                            .filter(
                                                (media) =>
                                                    media.serverId || media.url
                                            )
                                            .map(
                                                (media) =>
                                                    media.serverId || media.url
                                            ).length
                                        ? [
                                              'media',
                                              item[1]
                                                  .filter(
                                                      (media) =>
                                                          media.serverId ||
                                                          media.url
                                                  )
                                                  .map(
                                                      (media) =>
                                                          media.serverId ||
                                                          media.url
                                                  ),
                                          ]
                                        : undefined;
                                } else if (item[0].match(/size|balance|paid|purchased/)) {
                                    return;
                                } else if (item[0] === 'bra') {
                                    delete item[1]._id;
                                    item[1] = {
                                        ...Object.entries(item[1]).reduce(
                                            (a, [k, v]) =>
                                                v == null ? a : ((a[k] = v), a),
                                            {}
                                        ),
                                        color: item[1].color.replace('#', ''),
                                    };
                                    return item;
                                } else {
                                    return item;
                                }
                            })
                            .filter((item) => item)
                    ),
                })
            )
            .map((item, i, items) => {
                if (item?.id?.msrp && this.edit) {
                    items[i].id.msrp = item.msrp;
                    delete item.msrp;
                }
                return item
            });
            // prettier-ignore
            const { charity, name, description, mutableId, media } = self.$store.state.form.createWishlist;
            const fields = Object.fromEntries(
                Object.entries({
                    charity,
                    name,
                    description,
                    mutableId,
                    items: filteredItems,
                    media: media?.length
                        ? media
                              .filter((media) => media.serverId || media.url)
                              .map((media) => media.serverId || media.url)
                        : undefined,
                }).filter(([, v]) => v != null && v != '')
            );
            try {
                self.progress = true;
                if (this.edit) {
                    //console.log(this.wishlist);
                    await this.$backend.editWishlist({
                        id: this.wishlist.id,
                        fields,
                    });
                } else {
                    await this.$backend.createWishlist({ fields });
                }

                self.progress = false;
                self.reset();
            } catch (error) {
                self.progress = false;
                console.log({ error });
                this.errorMessage = error;
                this.error = true;
            }
        },
        async rendered() {
            // self is important here because whilst' scope doesn't include "this"
            const self = this;
            return whilst(
                function (callback) {
                    const componentsHaveRendered =
                        self?.$refs?.bra_url && self?.$refs?.filepond_wishlist;
                    callback(null, !componentsHaveRendered);
                },
                function (callback) {
                    //console.log('.');
                    Promise.delay(50).then(callback);
                },
                onRendered
            );
            function onRendered() {
                //console.log('!');
                self.$emit('mounted', self.$refs.form);
                self.brasizeInputHeight =
                    document.getElementById(
                        'bra_size'
                    )?.parentElement.offsetHeight;
            }
        },
        filepondOnload(response) {
            const fileField = response.split(':')[0];
            const serverId = response.split(':')[1];
            const inputId = fileField.split('_')[1];

            if (inputId === 'bra') {
                const assets = [{ serverId }];
                this.$store.commit('updateWishlistAssets', {
                    bras: assets,
                });
            } else {
                const assets = [{ serverId }];
                this.$store.commit('updateWishlistAssets', {
                    wishlist: assets,
                });
            }
            return serverId;
        },
        filepondProcessOnError(errorString) {
            let error = new Error(errorString);
            if (errorString.match(/insufficient scope/i)) {
                error = new Error('Please confirm your account first.');
            }

            this.$root.$emit('createFormError', error);
            return errorString;
        },
        filepondLoadOnError(response) {
            const self = this;
            const { type } = response;
            if (type === 'text/plain') {
                response.text().then(async (file) => {
                    const input = this.$refs.form.$data.inputs.find(
                        (input) =>
                            self.assets[input.id] &&
                            self.assets[input.id].serverId === file
                    );
                    if (!input) return;
                    await input.$el
                        .querySelector('.filepond--wrapper')
                        .__vue__.removeFiles();
                });
            }
            return response;
        },
        iconToUrl(icon, options = { width: 24, height: 24, fill: 'black' }) {
            const { width, height, fill } = options;
            const path = icon;
            const base64 = btoa(
                `<svg xmlns="http://www.w3.org/2000/svg" fill="${fill}" width="100" height="175" viewBox="0 0 ${height} ${width}" role="img" aria-hidden="true" class="v-icon__svg"><path d="${path}"></path></svg>`
            );
            const url = `data:image/svg+xml;base64,${base64}`;
            return url;
        },
        reset() {
            const self = this;
            self.$emit('reset');
            self.$store.commit('resetForm', 'createWishlist');
            self.$refs.form.reset();
            Object.keys(self.$refs)
                .filter((key) => key.match(/filepond_/))
                .map((key) => {
                    self.$refs[key] instanceof Array
                        ? self.$refs[key][0].removeFiles()
                        : self.$refs[key].removeFiles();
                });
            self.$nextTick(() => {
                self.$set(self.$refs.bra_color, 'lazyValue', self.swatch);
            });
        },
        roles() {
            return this.$auth.user
                ? this.$auth.user[`https://${tld}/roles`]
                : undefined;
        },
    },
};
</script>
